import { render } from "./FreebetPlayersActive.vue?vue&type=template&id=0e85c80e&scoped=true"
import script from "./FreebetPlayersActive.vue?vue&type=script&lang=js"
export * from "./FreebetPlayersActive.vue?vue&type=script&lang=js"

import "./FreebetPlayersActive.vue?vue&type=style&index=0&id=0e85c80e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e85c80e"]])

export default __exports__